import { Award } from "lucide-react";
import { awards } from "../data/awards";
import { languages } from "../data/languages";
import { SectionHeading } from "./SectionHeading";

export function AwardsLanguages() {
  return (
    <section id="awards" className="section shell">
      <SectionHeading
        number="06"
        eyebrow="Awards / communication"
        title="Competitive builds, global context."
        description="Four competition placements and the language range to collaborate across international teams."
      />
      <div className="awards-grid">
        {awards.map((award, index) => (
          <article className="award-card panel" key={award.title}>
            <div className="award-stamp"><Award aria-hidden="true" /><span>{award.rank}</span></div>
            <p className="eyebrow">Milestone / {String(index + 1).padStart(2, "0")}</p>
            <h3>{award.title}</h3>
            <div className="award-meta"><strong>{award.placement}</strong><span>{award.year}</span></div>
          </article>
        ))}
      </div>
      <div className="language-row" aria-label="Languages">
        <div className="language-intro"><p className="eyebrow">Languages</p><h3>Working across borders.</h3></div>
        {languages.map((language) => (
          <article key={language.language}>
            <span className="language-level">{language.level}</span>
            <div><h3>{language.language}</h3><p>{language.description}</p></div>
          </article>
        ))}
      </div>
    </section>
  );
}
